import { CommonModule } from "@angular/common";
import { Component, inject, Input, OnDestroy, OnInit } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { Subscription, Observable } from "rxjs";
import { PageInfoService, PageLink } from "src/app/_metronic/layout";
import { environment } from "src/environments/environment";
import { SharedModule } from "src/shared/shared.module";
import { PipesModule } from "src/utils/pipes/pipes.module";

@Component({
  selector: "app-course-description",
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    PipesModule,
    TranslateModule,
  ],
  templateUrl: "./course-description.component.html",
  styleUrl: "./course-description.component.scss",
})
export class CourseDescriptionComponent implements OnInit, OnDestroy {
  @Input() data: any;
  private unsubscribe: Subscription[] = [];

  #sanitizer = inject(DomSanitizer);
  #pageInfoService = inject(PageInfoService);
  fileUrl = environment.apiFileUrl;

  getTrustedVideoURL(videoURL: string): SafeResourceUrl {
    const regExp =
      /^.*(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/))([^#\&\?]*).*/;
    const match = videoURL.match(regExp);
    if (match && match[1].length === 11) {
      return this.#sanitizer.bypassSecurityTrustResourceUrl(
        `https://www.youtube.com/embed/${match[1]}`
      );
    }
    return this.#sanitizer.bypassSecurityTrustResourceUrl(videoURL);
  }

  title$: Observable<string>;
  bc$: Observable<Array<PageLink>>;

  ngOnInit(): void {
    this.title$ = this.#pageInfoService.title.asObservable();
    this.bc$ = this.#pageInfoService.breadcrumbs.asObservable();
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}
